module.exports = __webpack_public_path__ + "img/message4.0eabaab0.png";